var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.5312C30 6.50391 23.4961 0 15.4688 0C7.44141 0 0.9375 6.50391 0.9375 14.5312C0.9375 21.7969 6.21094 27.832 13.1836 28.8867V18.75H9.49219V14.5312H13.1836V11.3672C13.1836 7.73438 15.3516 5.68359 18.6328 5.68359C20.2734 5.68359 21.9141 5.97656 21.9141 5.97656V9.55078H20.0977C18.2812 9.55078 17.6953 10.6641 17.6953 11.8359V14.5312H21.7383L21.0938 18.75H17.6953V28.8867C24.668 27.832 30 21.7969 30 14.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFacebookLogo);
export default __webpack_public_path__ + "static/media/white-facebook-logo.fb3378ccb70bc5654213d0f8a7466016.svg";
export { ForwardRef as ReactComponent };